import Guard from '../../AppUtils/Framework/Guard'
import { BettingInformation } from '../Model/BettingInformation'
import { IBetTypeValidator } from './IBetTypeValidator'

export default class AllUpValidator implements IBetTypeValidator {
  constructor(public legs: number) {}

  isValid(bettingContext: BettingInformation): boolean {
    Guard.notNull(bettingContext)

    const selections = bettingContext.selections

    if (!selections) return false

    return (
      selections.betweenTwoAndSixLegsWithSelections() &&
      selections.quinellaLegsHaveNoneOrTwoSelectionsMinimum()
    )
  }
}
